import { ApiError, useGetPortalHome } from '@myrentalmate/api-client';

import { okData } from '../../lib/apiData';

/** The resident's home data. A 403 means this login isn't linked to a resident record yet. */
export function usePortalHome() {
  const query = useGetPortalHome({ query: { retry: false } });
  return {
    home: okData(query.data),
    notLinked: query.error instanceof ApiError && query.error.status === 403,
    isError: query.isError,
  };
}
